export class IstanzaAssegnazione {
  id: string;
  assegnato: boolean;
  dataIstanza: number;
}
